// Libraries
import I18n from 'i18next'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { message, Modal, Tag } from 'antd'
import { get, includes, toNumber, defaultTo, isNil, map } from 'lodash'

// Ressources
import { actions as siloActions } from 'Resources/SiloResource'
import { actions as basinActions } from 'Resources/BasinResource'

// Common components
import { TableLayout, ManageModal } from 'Components'

// Styles
import './SilosScreen.less'

const { confirm } = Modal

class SilosScreen extends Component {
  static propTypes = {
    // Actions d'API
    actions: PropTypes.object,

    // DonnÃ©es de la vue
    silo: PropTypes.object,
    silos: PropTypes.array,
    basins: PropTypes.array,

    // TÃ©moin d'activitÃ© API
    isGathering: PropTypes.bool,
    isUpdating: PropTypes.bool,
    isCreating: PropTypes.bool,

    // Structure du tableLayout
    buttons: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    table: PropTypes.object,

    // Structure de la manageModal
    manageModal: PropTypes.object,

    // Navigation interne
    navigation: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
      getParam: PropTypes.func.isRequired
    })
  }

  static defaultProps = {
    // Actions d'API
    actions: {},

    // DonnÃ©es de la vue
    silo: {},
    silos: [],
    basins: [],

    // TÃ©moin d'activitÃ© API
    isGathering: false,
    isUpdating: false,
    isCreating: false,

    // Structure du tableLayout
    table: {
      // Actions groupÃ©es
      actions: {
        global: {
          create: {
            label: 'common.create',
            icon: 'plus'
          }
        },
        selection: {
          // archive: {
          //   buttonType: 'danger'
          // },
          // update: {
          //   buttonType: 'primary'
          // },
          delete: {
            buttonType: 'danger'
          }
        }
      },

      // Gestion de l'internationalisation
      locale: {
        emptyText: 'pages.silos.table.empty'
      },

      // Gestion de la pagination
      pagination: {
        position: 'both',
        showSizeChanger: true,
        pageSizeOptions: ['10', '25', '50', '100']
      },

      // Identifiant unique de chaque ligne du tableau
      rowKey: 'id',

      // Colonnes du tableau
      columns: {
        name: {
          title: 'pages.silos.table.columns.name.title',
          dataIndex: 'name',
          key: 'name',
          sorter: (a, b) =>
            defaultTo(get(a, 'name'), '').localeCompare(
              defaultTo(get(b, 'name'), '')
            ),
          defaultSortOrder: 'ascend'
        },
        surface: {
          title: 'pages.silos.table.columns.surface.title',
          dataIndex: 'surface',
          key: 'surface',
          render: surface =>
            !isNil(surface)
              ? `${defaultTo(surface, 0).toLocaleString()} mÂ²`
              : I18n.t('common.none.female'),
          sorter: (a, b) =>
            defaultTo(get(a, 'surface'), 0) - defaultTo(get(b, 'surface'), 0)
        },
        overflowVolume: {
          title: 'pages.silos.table.columns.overflowVolume.title',
          dataIndex: 'overflowVolume',
          key: 'overflowVolume',
          render: overflowVolume =>
            !isNil(overflowVolume)
              ? `${defaultTo(overflowVolume, 0).toLocaleString()} mÂ³`
              : I18n.t('common.none.male'),
          sorter: (a, b) =>
            defaultTo(get(a, 'overflowVolume'), 0) -
            defaultTo(get(b, 'overflowVolume'), 0)
        },
        basin: {
          title: 'pages.silos.table.columns.basin.title',
          dataIndex: 'basin',
          key: 'basin',
          render: basin => (
            <Tag color={isNil(get(basin, 'name')) ? 'orange' : 'lime'}>
              {defaultTo(get(basin, 'name'), I18n.t('common.none.male'))}
            </Tag>
          ),
          sorter: (a, b) =>
            defaultTo(get(a, 'basin.name'), '').localeCompare(
              defaultTo(get(b, 'basin.name'), '')
            )
        }
      }
    },

    // Structure de la manageModal
    manageModal: {
      title: {
        update: 'pages.silos.modal.update.single.title',
        create: 'pages.silos.modal.create.single.title'
      },
      okText: {
        update: 'pages.silos.modal.update.single.okText',
        create: 'pages.silos.modal.create.single.okText'
      },
      actions: {
        delete: {
          buttonType: 'danger'
        }
      },
      rows: {
        name: {
          title: 'pages.silos.modal.rows.name.title',
          dataIndex: 'name',
          key: 'name',
          formField: {
            label: 'pages.silos.modal.rows.name.title',
            required: 'pages.silos.modal.rows.name.requiredMessage',
            placeholder: 'pages.silos.modal.rows.name.placeholder'
          }
        },
        surface: {
          title: 'pages.silos.modal.rows.surface.title',
          dataIndex: 'surface',
          key: 'surface',
          formField: {
            label: 'pages.silos.modal.rows.surface.title',
            required: 'pages.silos.modal.rows.surface.requiredMessage',
            placeholder: 'pages.silos.modal.rows.surface.placeholder',
            pattern: {
              pattern: '^(?=.)(([0-9]*)([\\.,]([0-9]+))?)$',
              transform: value => String(value),
              message: 'pages.silos.modal.rows.surface.patternMessage'
            },
            addonAfter: 'mÂ²',
            format: surface => (!isNil(surface) ? toNumber(surface) : undefined)
          }
        },
        overflowVolume: {
          title: 'pages.silos.modal.rows.overflowVolume.title',
          dataIndex: 'overflowVolume',
          key: 'overflowVolume',
          formField: {
            label: 'pages.silos.modal.rows.overflowVolume.title',
            required: 'pages.silos.modal.rows.overflowVolume.requiredMessage',
            placeholder: 'pages.silos.modal.rows.overflowVolume.placeholder',
            pattern: {
              pattern: '^(?=.)(([0-9]*)([\\.,]([0-9]+))?)$',
              transform: value => String(value),
              message: 'pages.silos.modal.rows.overflowVolume.patternMessage'
            },
            addonAfter: 'mÂ³',
            format: overflowVolume =>
              !isNil(overflowVolume) ? toNumber(overflowVolume) : undefined
          }
        },
        basin: {
          title: 'pages.silos.modal.rows.basin.title',
          dataIndex: 'basin',
          key: 'basin',
          formField: {
            type: 'searchSelect',
            label: 'pages.silos.modal.rows.basin.title',
            required: 'pages.silos.modal.rows.basin.requiredMessage',
            placeholder: 'pages.silos.modal.rows.basin.placeholder',
            format: basin => get(basin, 'id')
          }
        }
      }
    }
  }

  constructor(props) {
    super(props)

    this.state = {
      openedModal: null
    }
  }

  componentDidMount = () => {
    // RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
    this.fetchSilosData()

    // RÃ©cupÃ©ration des donnÃ©es des cuvettes pour association dans modale
    this.fetchBasinsData()
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
   */
  fetchSilosData = () => {
    this.props.actions.fetchSilos().catch(() => {
      message.error(I18n.t('api.errors.silo.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des cuvettes pour association dans modale
   */
  fetchBasinsData = () => {
    this.props.actions.fetchBasins().catch(() => {
      message.error(I18n.t('api.errors.basin.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es dÃ©taillÃ©es d'un Ã©lÃ©ment de la vue
   */
  getSiloData = silo =>
    new Promise((resolve, reject) => {
      this.props.actions
        .getSilo(silo)
        .then(response => {
          // DÃ©tails rÃ©cupÃ©rÃ©s
          resolve(get(response, 'body'), response)
        })
        .catch(error => {
          // Erreur lors du refresh
          reject(error)
          message.error(I18n.t('api.errors.silo.get'))
        })
    })

  /**
   * Actions groupÃ©e:
   * Archivage de plusieurs lignes du tableau
   */
  archiveSilos = (silos, clearTableSelections) => {
    this.props.actions
      .archiveSilos(silos)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.silo.bulk.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.silo.bulk.archive'))
      })
  }

  /**
   * Archivage d'une ligne du tableau
   */
  archiveSilo = silo => {
    this.props.actions
      .archiveSilo(silo)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.silo.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.silo.archive'))
      })
  }

  /**
   * Actions groupÃ©e:
   * Suppression de plusieurs lignes du tableau
   */
  deleteSilos = (silos, clearTableSelections) => {
    this.props.actions
      .deleteSilos(silos)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.silo.bulk.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.silo.bulk.delete'))
      })
  }

  /**
   * Suppression d'une ligne du tableau
   */
  deleteSilo = silo => {
    this.props.actions
      .deleteSilo(silo)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.silo.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.silo.delete'))
      })
  }

  /**
   * Mise Ã  jour d'un silo
   */
  updateSilo = (updatedSilo, originalSilo) =>
    new Promise((resolve, reject) => {
      this.props.actions
        .updateSilo({ id: get(originalSilo, 'id'), ...updatedSilo })
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.silo.update'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.silo.update'))
        })
    })

  /**
   * CrÃ©ation d'un silo
   */
  createSilo = createdSilo =>
    new Promise((resolve, reject) => {
      this.props.actions
        .createSilo(createdSilo)
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.silo.create'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.silo.create'))
        })
    })

  /**
   * Actions groupÃ©e:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askArchiveSilos = (...params) => {
    confirm({
      title: I18n.t('pages.silos.modal.archive.multiple.title'),
      content: I18n.t('pages.silos.modal.archive.multiple.content'),
      okText: I18n.t('pages.silos.modal.archive.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.silos.modal.archive.multiple.cancelText'),
      onOk: () => {
        this.archiveSilos(...params)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askArchiveSilo = () => {
    const silo = get(this.props, 'silo')

    confirm({
      title: I18n.t('pages.silos.modal.archive.single.title'),
      content: I18n.t('pages.silos.modal.archive.single.content'),
      okText: I18n.t('pages.silos.modal.archive.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.silos.modal.archive.single.cancelText'),
      onOk: () => {
        this.archiveSilo(silo)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Actions groupÃ©e:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askDeleteSilos = (...params) => {
    confirm({
      title: I18n.t('pages.silos.modal.delete.multiple.title'),
      content: I18n.t('pages.silos.modal.delete.multiple.content'),
      okText: I18n.t('pages.silos.modal.delete.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.silos.modal.delete.multiple.cancelText'),
      onOk: () => {
        this.deleteSilos(...params)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askDeleteSilo = () => {
    const silo = get(this.props, 'silo')

    confirm({
      title: I18n.t('pages.silos.modal.delete.single.title'),
      content: I18n.t('pages.silos.modal.delete.single.content'),
      okText: I18n.t('pages.silos.modal.delete.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.silos.modal.delete.single.cancelText'),
      onOk: () => {
        this.deleteSilo(silo)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Ouverture de la modale de modifications
   */
  openModal = (creating = true) => {
    this.setState({ openedModal: creating ? 'createSilo' : 'updateSilo' })
  }

  /**
   * Fermeture de toutes les modales
   */
  handleCloseModal = () => {
    const { openedModal } = this.state

    if (openedModal === 'updateSilo') {
      this.setState({ openedModal: 'transition' }, () => {
        setTimeout(this.setState({ openedModal: null }), 200)
      })
    } else {
      this.setState({ openedModal: null })
    }
  }

  /**
   * Callback:
   * CrÃ©ation d'une ligne de tableau rÃ©ussie
   */
  handleSiloCreated = () => {
    this.handleCloseModal()
  }

  /**
   * Clic sur une ligne du tableau
   */
  handleRowClick = silo => {
    this.getSiloData(silo)
    this.setState({ openedModal: 'updateSilo' })
  }

  render() {
    const {
      table,
      isGathering,
      manageModal,
      isUpdating,
      isCreating,
      silos,
      silo,
      basins
    } = this.props
    const { openedModal } = this.state

    // GESTION DES TABLEAUX

    // Ajout des donnÃ©es au tableau
    table.rows = silos

    // Ajout des actions au clic sur un ligne du tableau
    table.onRow = (silo, id) => ({
      onClick: () => this.handleRowClick(silo, id)
    })

    // Ajout des actions multiples sur le tableau
    // table.actions.selection.archive.onClick = this.askArchiveSilos
    table.actions.selection.delete.onClick = this.askDeleteSilos
    // table.actions.selection.update.onClick = this.askUpdateSilos

    // GESTION DES BOUTONS

    // Ajout des actions des boutons
    table.actions.global.create.onClick = this.openModal

    // GESTION DE LA MODALE DE GESTION

    // Ajout des actions sur la modale
    manageModal.actions.delete.onClick = this.askDeleteSilo

    // Ajout des options pour le choix d'une cuvette
    manageModal.rows.basin.formField.options = map(basins, basin => ({
      id: get(basin, 'id'),
      label: get(basin, 'name'),
      disabled: false,
      value: get(basin, 'id')
    }))

    // GESTION DES LOADERS
    const loading = isGathering || isUpdating || isCreating

    return (
      <main className='screen silos'>
        {/* Affichage des donnÃ©es de la page */}
        <TableLayout
          elementName='silo'
          elementKind='male'
          elementConsonant
          loading={loading}
          {...table}
        />

        {/* Ouverture de la modale de crÃ©ation / modification */}
        <ManageModal
          loading={loading}
          onCancel={this.handleCloseModal}
          onOk={this.handleSiloCreated}
          onChange={
            openedModal === 'updateSilo' ? this.updateSilo : this.createSilo
          }
          visible={includes(['createSilo', 'updateSilo'], openedModal)}
          data={
            includes(['transition', 'updateSilo'], openedModal) ? silo : null
          }
          {...manageModal}
        />
      </main>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(SilosScreen, 'defaultProps', {})

  return {
    silo: defaultTo(get(state, 'silo.item'), defaultProps.silo),
    silos: defaultTo(get(state, 'silo.items'), defaultProps.silos),
    basins: defaultTo(get(state, 'basin.items'), defaultProps.basins),
    isGathering:
      defaultTo(get(state, 'silo.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'basin.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'silo.isFetchingItem'), defaultProps.isGathering),
    isUpdating: defaultTo(
      get(state, 'silo.isUpdating'),
      defaultProps.isUpdating
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...siloActions, ...basinActions }, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SilosScreen)
